// Clerk renders modals in a portal, so listen on the document and scope to signup.
// These Clerk appearance classes are an integration dependency; keep browser tests
// in sync when upgrading Clerk. Never inspect or capture field values.
export function observeSignupInteractions(onStarted: () => void): () => void {
  const handleInteraction = (event: Event) => {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    const target = event.target;
    const root = target.closest(".cl-signUp-root");
    if (!root) return;

    if (event.type === "input" || event.type === "change") {
      if (target.matches("input:not([type=hidden]):not([type=submit]):not([type=button]):not([type=reset]), textarea, select")) onStarted();
      return;
    }
    if (event.type === "submit") {
      if (target.matches("form")) onStarted();
      return;
    }
    const button = target.closest("button, a");
    if (!button || !root.contains(button) || button.matches(":disabled, [aria-disabled=true]")) return;
    if (button.matches(".cl-formButtonPrimary, .cl-socialButtonsBlockButton, .cl-socialButtonsIconButton, .cl-alternativeMethodsBlockButton__enterprise_sso") ||
        button.querySelector(".cl-enterpriseButtonsProviderIcon")) onStarted();
  };
  const events = ["input", "change", "submit", "click"];
  events.forEach((name) => document.addEventListener(name, handleInteraction, true));
  return () => events.forEach((name) => document.removeEventListener(name, handleInteraction, true));
}
